import { FormGroup, Label, Input } from 'reactstrap';
import { injectIntl } from 'react-intl';
import Info from 'src/componentes/info';

function Checkbox({
  cursor,
  intl,
  model,
  disabled,
  getAlteracao,
  showHint = false,
  idHint = 'defaultIdHint',
  labelHint = 'defaultLabelHint',
  ...rest
}) {
  const handleChange = (e) => {
    model.requestChange && model.requestChange(e.target.checked);

    if (getAlteracao != null) {
      getAlteracao();
    }
  };

  const hasLabel = !!model.label;

  return (
    <FormGroup
      check
      validationstate={model && model.errors ? 'error' : null}
      {...rest}
    >
      <Label
        check
        style={{
          display: 'inline-flex',
          alignItems: hasLabel ? 'flex-start' : 'center',
          ...rest.styleLabel,
        }}
      >
        <Input
          type="checkbox"
          disabled={disabled}
          checked={model.value}
          onChange={handleChange}
          style={{
            marginTop: hasLabel ? 2 : 0,
            marginBottom: 0,
            cursor: cursor,
          }}
        />
        {model.label &&
          (model.label.props
            ? intl.formatMessage({ ...model.label.props })
            : model.label)}
        {showHint && (
          <Info
            id={idHint}
            className={'pl-1'}
            placement="right"
            text={labelHint}
          />
        )}
      </Label>
    </FormGroup>
  );
}

export default injectIntl(Checkbox);